import React from 'react';
import { lang } from '../services';

import SvgIcon from './icons/SvgIcon';

const MainTitle = () => {
    return (
        <div className="MainTitle">
            <div className='MainTitle__titleWrapper'>
                <span className="MainTitle__title">{lang.t('Easy and fast')}</span><br />
                <span className="MainTitle__titleNoWrap">
                    {lang.t('surfing') + ' – '}
                    <span className="MainTitle__titleMarked">{lang.t('for free')}</span>
                </span>
            </div>
            <SvgIcon icon={SvgIcon.MAIN_TITLE} />
            <div className='MainTitle__description'>{lang.t('Open any blocked websites fast and for free')}</div>
        </div>
    )
};

export default MainTitle;

